import React from 'react';
import styledComponents from 'styled-components';
import { BsKeyFill } from 'react-icons/bs';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { getAuthContext } from 'contexts/auth';
import { getReferenceContext } from 'contexts/reference';
import { passwordPolicyCheck, renderPasswordPolicyCheck } from '../utils/passwordPolicy';

const ForceUpdatePass = ({defaultPassword, email, user, setLoggedIn }) => {
    const { setUser } = React.useContext(getAuthContext);
    const [password, setPassword] = React.useState('');
    const [password2, setPassword2] = React.useState('');
    const { setIsLoading } = React.useContext(getReferenceContext)

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        try {
            if (password !== password2) return NotificationManager.warning('Нууц үг таарахгүй байна', '', 0);
            if (password === defaultPassword) {setIsLoading(false); NotificationManager.warning('Шинээр нууц үг оруулна уу', '', 0); return};
            if (!passwordPolicyCheck(password).valid) return NotificationManager.warning('Нууц үг дүрмийн дагуу үүсгээрэй', '', 0);
            await Auth.completeNewPassword(user, password);
            NotificationManager.success('Амжилттай', '', 0);
            setUser(user)
            setLoggedIn(true);
            setIsLoading(false)

            navigate('/');
        } catch (error) {
            console.log({ error });
            setIsLoading(false)
            if(error.__type === 'PasswordHistoryPolicyViolationException'){
                NotificationManager.error('Өмнө ашигласан нууц үгээр дахин ашиглах боломжгүй', 'Error', 0);
            }else{
                NotificationManager.error(error.message, 'Error', 0);
            }
        }
    };
    return (
        <Container>
            <img src="/logo.png" alt='logo' />
            <h2>Нэвтрэх</h2>
            <input required disabled value={email} type="text" placeholder="И-мэйл хаяг" name="email" />
            <input required value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Нууц үг" name="password" />
            <div>{renderPasswordPolicyCheck(password)}</div>
            <input required value={password2} onChange={(e) => setPassword2(e.target.value)} type="password" placeholder="Нууц үг давтаж оруулах" name="password2" />
            <button onClick={handleSubmit} disabled={!passwordPolicyCheck(password).valid}>
                <BsKeyFill />
                Нэвтрэх
            </button>
        </Container>
    );
};

export default ForceUpdatePass;

const Container = styledComponents.form`
    display:flex;
    height:100vh;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width:300px;
    margin:auto;
    h2 {
      margin:15px 0;
    }
    img{
        width:100px;
    }
    .forgot_wrap{
        font-size:12px;
        text-align:center;
        margin-top:10px;
        color: ${({ theme }) => theme.lightblue};
        text-decoration:underline;
        cursor:pointer;
    }
    input[type="text"],input[type="password"]{
        border: 1px solid rgba(0, 0, 0, 0.2);
        padding: 10px 14px;
        outline: none;
        transition: all 0.3s ease 0s;
        border-radius: 4px;
        box-sizing: border-box;
        text-overflow: ellipsis;
        margin-bottom:10px;
        width:100%;
        font-size:13px;
        &:focus{
            border-color: rgba(0, 0, 0, 0.8);
            box-shadow: rgba(0 0 0 / 25%) 0px 0px 0px 2px;
        }
    }
    button{
        display:flex;
        align-items:center;
        justify-content:center;
        svg{
            font-size:18px;
            margin-right:5px;
        }
        text-transform:capitalize;
        padding:10px 16px;
        background:${({ theme }) => theme.color};
        color:white;
        border:none;
        border-radius:6px;
        font-weight:500;
        position:relative;
        overflow:hidden;
        cursor:pointer;
        width:100%;

        &:disabled {
            background: #cccccc;
            cursor: not-allowed;
            opacity: 0.7;
        }
    }
    button[type="button"]{
        background:${({ theme }) => theme.dark};
        margin-top:5px;
    }
`;
